import { render } from "./identification.vue?vue&type=template&id=295833af"
import script from "./identification.vue?vue&type=script&lang=js"
export * from "./identification.vue?vue&type=script&lang=js"

import "./identification.vue?vue&type=style&index=0&id=295833af&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__